import { Injectable } from '@angular/core';
import { ISplugParametersConfigurationDto, LSplug } from 'core/dto';
import { Observable, map } from 'rxjs';
import { ApiService } from '../api.service';
import { controllerEndpoints } from '../controller.endpoints';
import { crudEndpoints } from '../crud.endpoints';
import { customEndpoints } from '../custom.endpoints';
import joinUrls from '../utils.ts/join-urls';
import { ICrudAdvancedMethods } from './types/i-crud-advanced.methods';
import { ICrudBasicMethods } from './types/i-crud-basic.methods';
import { IGetByActivity } from './types/i-get-by-activity';
import { IGetByProcess } from './types/i-get-by-process';

@Injectable({
  providedIn: 'root'
})
export class SplugParametersConfigurationRemoteControllerService implements
  Pick<ICrudBasicMethods<ISplugParametersConfigurationDto>, 'getOne'>,
  IGetByProcess<ISplugParametersConfigurationDto>,
  Pick<ICrudAdvancedMethods<ISplugParametersConfigurationDto>, 'insertBatch' | 'removeBatch'>,
  IGetByActivity<ISplugParametersConfigurationDto>
{

  private readonly _endpoint = controllerEndpoints.SPLUG_PARAMETERS_CONFIGURATION

  constructor(
    private readonly _apiService: ApiService
  ) {

  }

  getOne(id: string): Observable<ISplugParametersConfigurationDto<LSplug>> {

    const getOneEndpoint = joinUrls(this._endpoint, id)

    return this._apiService.get(getOneEndpoint)
  }


  getByActivity(activityId: string): Observable<ISplugParametersConfigurationDto[]> {
    const getByActivityEndpoint = joinUrls(this._endpoint, customEndpoints.GET_BY_ACTIVITY_ID, activityId);
    return this._apiService.get(getByActivityEndpoint)
  }

  getByProcess(processId: string): Observable<ISplugParametersConfigurationDto[]> {
    const getByProcessEndpoint = joinUrls(this._endpoint, customEndpoints.GET_BY_PROCESS_ID, processId);

    return this._apiService.get<ISplugParametersConfigurationDto[]>(getByProcessEndpoint);
  }

  insertBatch(insertDtoArray: Partial<ISplugParametersConfigurationDto>[]): Observable<ISplugParametersConfigurationDto[]> {
    return this._apiService.post<{ status: { code: number, message: string } }>(this._endpoint, insertDtoArray)
      .pipe(map(({ status }) => (status.code === 0 ? insertDtoArray : []) as ISplugParametersConfigurationDto[]))
  }

  removeBatch(removeIds: string[]): Observable<unknown> {
    const removeBatchEndpoint = joinUrls(this._endpoint, crudEndpoints.DELETE_BATCH);
    return this._apiService.post<undefined>(removeBatchEndpoint, removeIds);
  }


  getByUser(userId: string) {
    //TODO
    const getByProcessEndpoint = joinUrls(this._endpoint, customEndpoints.GET_BY_PROCESS_ID, userId);

    return this._apiService.get<ISplugParametersConfigurationDto[]>(getByProcessEndpoint);
  }
}
